// JS libraries included in plugins.min.js
$(window).setBreakPoints([360,540,768,1024,1200]);

// Detects Touch Event
window.addEventListener('touchstart',function onFirstTouch(){
	document.documentElement.className += " touch";
	window.removeEventListener('touchstart', onFirstTouch, false);
}, false);

// Detects Instagram
var uaString = navigator.userAgent || navigator.vendor || window.opera;
if (uaString.toLowerCase().includes('instagram')){
	document.documentElement.className += " instagram";
}

// Global Variables - Page/Viewport Heights
var pageHeight;
var viewHeight;
var headerHeight;

// Declares global variable for ScrollMagic Controller
var ScrollMagicConroller;

// Vimeo Tab Videos
var vimeoTabVideos = new Array();

// jQuery Ready Functions
$(document).ready(function(){

	// Sets Element Height Values
	pageHeight = $('body').outerHeight();
	viewHeight = vhCheck().vh;
	headerHeight = $('header .container').outerHeight();

	// Global Banners
	// initEyebrow();
	initCCPA();

	if (isPage('home')){
		initScrollMagic();
		initScrollMenu();
		initContactForm();
	}
});

// =====================================================================
// Footer Request Contact - JotForm Load
// =====================================================================
function initContactForm(){

	$('#contact a.button').click(function(event){
		event.preventDefault();
  		this.blur();

		// Adds Background Lock Event
		lockWindow();

		// Modal & Form IDs
		var modalID = $(this).attr('href');
		var jotformURL = $(this).data('jotform');

		// Check to see if JotForm iframe has been loaded
		if ($(modalID).find('iframe').length != 1) {
			// JotForm first load
			var script = document.createElement('script');
			script.type = 'text/javascript';
			script.src = jotformURL;
			document.getElementById(modalID.replace('#','')).appendChild(script);
		}
		// Opens Modal
		$(modalID).modal({
			escapeClose: true,
			clickClose: true,
			showClose: true
		 });

		// On Close: Empty modal, Removes Background Unlock Event
		// Empty modal to prevent JotForm from reloading after the div changes to display:none;
		$(modalID).on($.modal.BEFORE_CLOSE, function(event,modal){
			$(this).off($.modal.BEFORE_CLOSE);
			$(modalID).empty();
			unlockWindow();
		});
	});

}

// =====================================================================
// Footer CCPA Banner
// =====================================================================
function initCCPA(){
	var cookie = Cookies.get('GDPR_Cookie_Banner_Shown');
	var showBanner = true;
	if (cookie !== undefined && cookie == 'true'){
		showBanner = false;
	}

	if (showBanner){
		$('#ccpa').slideDown(300,'linear',function(){});

		$('#ccpa button#close').click(function(){
			$('#ccpa').slideUp(300,'linear',function(){
				Cookies.set('GDPR_Cookie_Banner_Shown','true');
			});
		});
		$('#ccpa button#accept').click(function(){
			$('#ccpa').slideUp(300,'linear',function(){
				Cookies.set('GDPR_Cookie_Banner_Shown','true');
			});
		});
	}

}

// =====================================================================
// Eyebrow Banner
// =====================================================================
function initEyebrow(){
	var cookie = Cookies.get('Eyebrow_Banner_Shown');
	var showBanner = true;
	if (cookie !== undefined && cookie == 'true'){
		showBanner = false;
	}

	if (showBanner){
		$('body').addClass('show-eyebrow');
		updateScrollMagic();

		$('#eyebrow button.close').click(function(){
			$('body').removeClass('show-eyebrow');
			Cookies.set('Eyebrow_Banner_Shown','true');
			updateScrollMagic();
		});
	}

	function updateScrollMagic(){
		setTimeout(function(){
			$('body').trigger('eyebrowResize');
			scrollPage('#top');
		}, 500);
	}
}

// =====================================================================
// Fixed Navigation for Desktop
// =====================================================================
function initScrollMagic(){

	ScrollMagicConroller = new ScrollMagic.Controller({
		globalSceneOptions: {
			triggerHook: 'onLeave'
		}
	});

	// Section inView Scenes
	var layoutSections = [];
	$('main > section:not(#hero)').each(function(key,value){
		var sectionName = $(this).attr('id');
		var sectionClass = 'active-'+sectionName;
		var selector = '#'+sectionName;
		layoutSections[key] = new ScrollMagic.Scene({
			triggerHook: 'onEnter',
			triggerElement: selector,
			reverse: true
		})
		//.addIndicators()
		.setClassToggle('header #navigation',sectionClass)
		.addTo(ScrollMagicConroller);
	});

	// Sets duration/offset after all scene have been defined
	updateScenes();

	// Triggers duration/offset update on resize
	$(window).resize(function(){
		updateScenes();
	});

	// Eyebrow Listener
	$('body').on('eyebrowResize', function(){
		updateScenes();
	});

	// Sets duration/offset, updates after scene created
	function updateScenes(){
		// Updates Globals
		pageHeight = $('body').outerHeight();
		viewHeight = vhCheck().vh;
		headerHeight = $('header').outerHeight();

		// Fixed Nav only for Desktop
		if ($(window).getBreakPoint() >= 1024){
			// Updates Section Scenes
			for (i=0; i<layoutSections.length; i++){
				selector = "#"+layoutSections[i].triggerElement().getAttribute('id');
				layoutSections[i].offset(headerHeight * -1);
				layoutSections[i].duration($(selector).outerHeight());
			}
			// Enables ScrollMagic
			ScrollMagicConroller.enabled(true);
			ScrollMagicConroller.update(true);
		} else {
			// Disables ScollMagic for Mobile
			ScrollMagicConroller.enabled(false);
			ScrollMagicConroller.update(true);
		}
	}
}

// =====================================================================
// Global Functions: Modal Open/Close, Window Lock/Unlock, Window Scroll
// =====================================================================
function openModal(modalView,modalInner){

	// Locks the background window and opens modal
	lockWindow(function(){
		$('#modal').addClass(modalView);
		if (modalInner !== ''){
			$('#modal').addClass(modalInner);
		}
		$('html').addClass('showModal');
	});

	// Close Modal Button Listener
	$('#modal .modal-box .close').unbind('click').click(function(event){
		event.preventDefault();
		closeModal();
	});
}
function closeModal(){
	// Unlocks the background window and closes modal
	unlockWindow(function(){
		$('html').removeClass('showModal');

		// Stops video if enabled
		if (typeof vimeoModalPlayer != 'undefined'){
			vimeoModalPlayer.pause();
			vimeoModalPlayer.setCurrentTime(0);
		}

		// wait for the modal to fade out
		setTimeout(function(){
			$('#modal').attr('class','');
		}, 250);
	});

}
function lockWindow(callback){
	// Locks the background window
	var scrollPos = $(window).scrollTop();
	$('body').data('scrollPos',scrollPos);
	scrollPos = scrollPos * -1;
	$('html').addClass('noScroll').css('top',scrollPos+'px');
	if(callback !== undefined){
		callback();
	}
}
function unlockWindow(callback){
	// Unlocks the background window
	$('html').removeClass('noScroll').css('top','');
	$(window).scrollTop($('body').data('scrollPos'));
	if(callback !== undefined){
		callback();
	}
}
function scrollPage(scrollTo,callback){

	// Calculates Scroll Position
	var scrollPos = 0;
	if (scrollTo == "#top"){
		scrollPos = 0;
	} else {
		scrollPos = $(scrollTo).offset().top - headerHeight;
		if ($(window).getBreakPoint() >= 1024){
			// Ensures fixed menu choice changes on desktop
			scrollPos += 2;
		}
	}

   // Scroll down
	$('html, body').addClass('scrolling').animate({
		scrollTop: scrollPos
	}, {duration: 500, easing: 'linear'}).promise().then(function(){
      $('html, body').removeClass('scrolling');
		if(callback !== undefined){
			callback();
		}
   });
}

// =====================================================================
// Fixed Desktop Menu and Mobile Menu
// =====================================================================
function initScrollMenu(){

	// Menu Item Click
	$('a.scrollMenu').click(function(event){
		event.preventDefault();
		// Scrolls to next point
		scrollPage($(this).attr('href'));
	});

}

// ===================================================================
// Global Function to tell what page is viewed based on body class/ID
// ===================================================================
function isPage(a){
	if($('body#'+a).length){return true;}
	else if ($('body').hasClass(a)){return true;}
	else if ($('body').hasClass('page-'+a)){return true;}
	else{return false;}
}

// ===================================================================
// Global Function to push GA events to GTM dataLayer (depreciated)
// ===================================================================
function pushGAevent(category,action,label){
	if (typeof window.dataLayer !== 'undefined'){
		window.dataLayer.push({
			'event': 'Google Analytics - Event',
			'GAEvent_category': category,
			'GAEvent_action': action,
			'GAEvent_label': label
		});
	}
 }

// ===================================================================
// Global Function to push global events to GTM dataLayer
// ===================================================================
function pushGTMevent(eventName,data = new Object()){
	if (typeof window.dataLayer !== 'undefined'){
		window.dataLayer.push({
			'event': eventName,
			'gtm': data
		});
	}
}